import React, { Component } from "react";
import BangerText from './../../components/bangerText';
import FeaturedCompanies from './../../components/featuredCompanies';
import VideoHero from './../../components/videoHero';
import Countdown from "./../../components/countdown";
import Footer from "./../../components/footer";
import EpicCardGrid from "./../../components/epicCardGrid";
import SideBySideCardAndImage from "./../../components/sideBySideCardAndImage";
import KnockoutComp from "./../../components/knockoutComp";
import ParallaxCollage1 from "./../../components/parallaxCollage1";
import ScrollHighlightText from "./../../components/scrollHighlightText";
import  './../../utils/analytics';
import {Colors} from './../../utils/variables';
import ScrollFadeIn from './../../components/scrollFadeIn';
import { Link } from "react-router-dom";

const YOUTUBE_VIDEO_ID = 'urTE_Vrn3wo';
const YOUTUBE_THUMB = `/images/teaser-thumb.jpg`;

export default class Home extends Component {
  state = { sectionVideoPlayed: false };

  componentDidMount = ()=>{
    window.scrollTo(0, 0)
  }

  playSectionVideo = () => this.setState({ sectionVideoPlayed: true });

  render() {
    return (
		<div>
			<VideoHero
				subtitle="Women's Mountain Biking Retreat"
				title={['Gear Up for the Ultimate ',<br />, 'MTB Weekend!']}
				video="9g6n-koREHI"
				height="full"
        verticalText='Kirkwood Mountain Resort'
        poweredByImage="/images/powered-by-ibis.png"
        tint="light"
			/>
      <ScrollFadeIn>
        <div className="countdown-section">
          {/* Temporary: Summer 2027 — restore August 14-16, 2027 / Aug 14, 2027 15:37:25 when dates are finalized */}
          <Countdown
            title="Summer 2027"
            time="Jun 1, 2027 00:00:00"
            titleColor={Colors.white}
            textColor={Colors.white}
            backgroundColor={Colors.primary}/>
        </div>
      </ScrollFadeIn>
      <div style={{ backgroundColor: Colors.primaryDark, backgroundImage: 'url(/images/topo-texture.png)', backgroundSize: 'cover', paddingBottom:'10rem' }}>
        <ScrollFadeIn>
          <div className="extra-large-padding centered-text" style={{ paddingBottom: '2rem', paddingTop:'14rem' }}>
            <h1 style={{ color: Colors.white, marginBottom: '1.25rem' }}>{"A Women's Only Event"}</h1>
            <p className="small-max-width-container subheading" style={{ color: Colors.white, marginBottom: '2rem', lineHeight: 1.5 }}>
              {"Join Peak Pursuits for a women's mountain biking retreat based in the Sierras. Spend the weekend on adventure rides with big climbs and fun downhills, community, bike clinics, and wellness workshops at the base of the mountains at Kirkwood Mountain Resort. You can plan to connect with like-minded individuals while ripping around on some of the most scenic trails in the area."}
            </p>
            <Link to="/event">
              <div className="card-button button" style={{ color: Colors.white, backgroundColor: Colors.tertiary }}>
                {'Learn More'}
              </div>
            </Link>
          </div>
          <div className="medium-max-width-container" style={{ padding: '0 1rem 4rem'}}>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
              {this.state.sectionVideoPlayed ? (
                <iframe
                  title="Peak Pursuits"
                  src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1`}
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  onClick={this.playSectionVideo}
                  aria-label="Play video"
                  style={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', margin: 0, padding: 0, border: 'none', cursor: 'pointer', background: `center/cover url(${YOUTUBE_THUMB})`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  <span style={{
                    width: 80, height: 80, borderRadius: '50%', backgroundColor: Colors.tertiary, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.4)', transition: 'transform 0.2s ease',
                  }}>
                    <span style={{ width: 0, height: 0, borderLeft: '24px solid #fff', borderTop: '14px solid transparent', borderBottom: '14px solid transparent', marginLeft: 8 }} />
                  </span>
                </button>
              )}
            </div>
          </div>
          </ScrollFadeIn>
        </div>

      <ScrollFadeIn>
        <KnockoutComp
        knockoutText="peak"
        knockoutOverlayImage="/images/knockout-overlay.png"
        title="The Steeper the Climb, the Better the Views"
        preTitle="No Shortcuts"
        knockoutTextBackground="/images/landscape.jpg"
        description={`It’s always steepest before the summit. But, if we just keep pedaling, we can turn life’s hardest things into life’s best things.
Because all mountains feel big, all uphill climbs hurt, and all peak pursuits are hard:`}
        cursiveText={'Do. It. Anyway'}
        buttonText="learn more"
        buttonTextColor={Colors.white}
        buttonBackgroundColor={Colors.tertiary}
        backgroundColor={Colors.primary}
        link="/story"
        textColor={Colors.white}
        verticalText='RIDER || AMANDA P'
        />
      </ScrollFadeIn>
      <div>
        <ScrollFadeIn>
          <div className="row" style={{color:Colors.white, minHeight:'90vh', alignItems:'center', backgroundColor:Colors.primary, backgroundImage:'url(/images/event-kicker.jpg)', backgroundSize:'cover', backgroundPosition:'center'}}>
            <div className="extra-large-padding centered-text small-max-width-container">
              <h4 style={{marginBottom:10}}><b>{"FREE TO ROAM"}</b></h4>
              <h1>{'Where You Look is Where You Go'}</h1>
              <p className="cursive-text" style={{lineHeight:1.3}}>{'Following a friend down a hard feature can make impossible feel possible. Let’s spend a girls only weekend riding bikes and learning from each other\'s climbs and crashes: the ones on and off the dirt. Bring your knee pads - this learning is happening in the field and on the best single-track around Kirkwood. With the support of the USFS and Kirkwood we are free to roam the wild spaces of the Sierras together. We may be biased, but Kirkwood is the best place to pedal and adventure. The ridgelines and meadows at the mountain will be the perfect backdrop for a weekend full of community and riding.'}</p>
              <Link to="/event">
                <div className="card-button button" style={{color:Colors.white, backgroundColor:Colors.tertiary}}>
                  {'Learn More'}
                </div>
              </Link>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
      <ScrollFadeIn>
      <EpicCardGrid
        title="Never Easier, just Faster"
        subtitle="Shifting Gears"
        description="Adventure isn’t clean and you won’t be either after a weekend riding bikes with us. The pursuit of summits, the ones on and off the bike, can get a bit messy. But that’s where we come in, as a hand extended when you feel like quitting the climb. Community in the hard places: it’s the secret to the summit."
        buttonText="More About Us"
        link="/story"
        buttonTextColor={Colors.white}
        buttonBackgroundColor={Colors.tertiary}
        backgroundColor={Colors.primaryDark}
        cardBackgroundColor={Colors.primary}
        titleColor={Colors.white}
        descriptionColor={Colors.white}
        parallaxImage1='/images/about-us-collage-1.jpg'
        parallaxImage2='/images/landscape-short.jpg'
        parallaxImage3='/images/about-us-collage-3.jpg'
        parallaxImage4='/images/about-us-collage-4.jpg'
      />
      </ScrollFadeIn>
      <ScrollFadeIn>
         <SideBySideCardAndImage
        title="Peak Purpose"
        description="Because what if the greatest thing we ever do with our time, is something we do for someone else?"
        buttonText="Learn about our non profit foundation"
        link="/peak-purpose"
        image="/images/peak-purpose-kicker.jpg"
        buttonTextColor={Colors.white}
        buttonBackgroundColor={Colors.tertiary}
        backgroundColor={Colors.primary}
        backgroundTexture="/images/topo-texture.png"
        cardBackgroundColor={Colors.primaryDark}
        titleColor={Colors.white}
        descrptionColor={Colors.white}
        slant={false}
        mobileReverse={true}
      />
      </ScrollFadeIn>
		</div>
    );
  }
}
